import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";

interface PageTransitionProps {
  children: React.ReactNode;
}

export function PageTransition({ children }: PageTransitionProps) {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);
  const [displayLocation, setDisplayLocation] = useState(location);

  useEffect(() => {
    if (location !== displayLocation) {
      // Fade out
      setIsVisible(false);
      
      // Wait for fade out, then update location and fade in
      const timeout = setTimeout(() => {
        setDisplayLocation(location);
        // Scroll to top on page change
        window.scrollTo(0, 0);
        setIsVisible(true);
      }, 200);

      return () => clearTimeout(timeout);
    }
  }, [location, displayLocation]);

  useEffect(() => {
    // Initial fade in
    const timeout = setTimeout(() => {
      setIsVisible(true);
    }, 50);
    return () => clearTimeout(timeout);
  }, []);

  // Use opacity only (no transform) to avoid breaking fixed positioning
  return (
    <div
      className={cn(
        "transition-opacity duration-300 ease-out",
        isVisible ? "opacity-100" : "opacity-0"
      )}
    >
      {children}
    </div>
  );
}
